import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { APIUrl } from "@/api/apiUserClient";
import { fetchJson } from "@/api/http";

// Replaces getList
export function useUsersList(page: number, perPage: number) {
  return useQuery({
    queryKey: ["users", "list", page, perPage],
    queryFn: async () => {
      const url = new URL(APIUrl);
      url.pathname = "user";
      url.searchParams.set("start", String((page - 1) * perPage));
      url.searchParams.set("amount", String(perPage));

      const { json } = await fetchJson(url.toString(), { method: "GET" });
      const items = json["items"].map((res: any) => ({
        ...res,
        id: res.email,
      }));

      return {
        data: items,
        total: 50, // This should come from the API
      };
    },
  });
}

// Replaces getOne ... used for viewing/editing a single user
export function useUser(id: string) {
  return useQuery({
    queryKey: ["users", id],
    queryFn: async () => {
      const { json } = await fetchJson(`${APIUrl}user/${id}`);
      return json["items"];
    },
  });
}

// Replaces create ... used in UsersCreate.tsx
export function useCreateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const url = new URL(APIUrl);
      url.pathname = "user";
      const { json } = await fetchJson(url.toString(), {
        method: "POST",
        body: JSON.stringify(data),
      });
      return json;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users", "list"] });
    },
  });
}

// Replaces update ... used in UsersEdit.tsx
export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const { json } = await fetchJson(`${APIUrl}user/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
      });
      return json;
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["users", "list"] });
      queryClient.invalidateQueries({ queryKey: ["users", id] });
    },
  });
}
